import { IAppealPreSubmissionProps } from "../../model/interface";
import { AppealType } from "../../model/enum";
import AccountAppealPreSubmission from "./AccountAppealPreSubmission";
import ContentAppealPreSubmission from "./ContentAppealPreSubmission";
import React from "react";

export default function AppealPreSubmission(props: IAppealPreSubmissionProps) {

    return (
        <React.Fragment>
            {(props.appealType === AppealType.Account) &&
                <AccountAppealPreSubmission
                    currentFormInfo={props.formInfo}
                    productChange={props.productChange}
                    nameChange={props.nameChange}
                    contactEmailChange={props.emailChange}
                    justificationChange={props.justificationChange}
                />
            }
             {(props.appealType === AppealType.Content) &&
                <ContentAppealPreSubmission
                    currentFormInfo={props.formInfo}
                    justificationChange={props.justificationChange}
                />
            }
        </React.Fragment>
    )
}